import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.activeMenuItem()

    this.onColorSchemaChange = this.applyTheme.bind(this)
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", this.onColorSchemaChange)
  }

  disconnect() {
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .removeEventListener("change", this.onColorSchemaChange)
  }

  light() {
    localStorage.theme = "light"
    this.applyTheme()
  }

  dark() {
    localStorage.theme = "dark"
    this.applyTheme()
  }

  clear() {
    localStorage.removeItem("theme")
    this.applyTheme()
  }

  applyTheme() {
    document.documentElement.dataset.theme =
      localStorage.theme ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light")

    this.activeMenuItem()
  }

  activeMenuItem() {
    this.buttonTargets.forEach((button) => {
      if (
        localStorage.theme === button.dataset.themeValue ||
        (!localStorage.theme && button.dataset.themeValue === "system")
      ) {
        button.classList.add("dropdown-active")
      } else {
        button.classList.remove("dropdown-active")
      }
    })
  }
}
